var _react_refresh_temp_1;
_react_refresh_temp_1 = $RefreshSig$();
import { createContext, useContext } from 'react';
export const DescribedByContext = createContext(undefined);
export const useDescribedBy = () => (_react_refresh_temp_1(), useContext(DescribedByContext));
_react_refresh_temp_1(useDescribedBy, "gDsCjeeItUuvgOWf1v4qoK9RF6k=");
